import { handleActions } from 'redux-actions';
import produce from 'immer';

const initialState = {
  currentMcq: {},
  mcqsQuestions: [],
  mcqsDetails: [],
  questionDetails: [],
  progress: {
    total: 0,
    answered: 0,
    marked: 0,
    skipped: 0,
  },
};

const McqReducer = handleActions(
  {
    ADD_MCQS_QUESTIONS: (state, action) =>
      produce(state, draft => {
        draft.mcqsQuestions.push(action.payload);
      }),
    SET_CURRENT_MCQ: (state, action) =>
      produce(state, draft => {
        draft.currentMcq = action.payload;
      }),
    SET_MCQS_DETAILS: (state, action) =>
      produce(state, draft => {
        draft.mcqsDetails = action.payload;
      }),
    SET_QUESTION_DETAILS: (state, action) =>
      produce(state, draft => {
        draft.questionDetails = action.payload;
      }),
    UPDATE_QUESTION_DETAILS: (state, action) =>
      produce(state, draft => {
        const { index, action: updateAction, value } = action.payload;
        if (!draft.questionDetails || index < 0 || index >= draft.questionDetails.length) {
          return;
        }
        switch (updateAction) {
          case 'visited':
            draft.questionDetails[index].visited = true;
            break;
          case 'answered':
            draft.questionDetails[index].answered = true;
            draft.questionDetails[index].answer = value;
            break;
          case 'unAnswered':
            draft.questionDetails[index].answered = false;
            draft.questionDetails[index].answer = [];
            break;
          case 'addToMarkedForReview':
            draft.questionDetails[index].markedForReview = true;
            break;
          case 'removeFromMarkedForReview':
            draft.questionDetails[index].markedForReview = false;
            break;
          default:
            break;
        }
      }),
    SET_PROGRESS: (state, action) =>
      produce(state, draft => {
        draft.progress = action.payload;
      }),
  },
  initialState,
);

export default McqReducer;
